module.exports = __webpack_public_path__ + "644786d7e409c3ceba86ff8e61d910e8.png";